import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LogsAgGridModule } from '@y42/log/shared';
import { JobLogsComponent } from './job-logs.component';

@NgModule({
  imports: [CommonModule, MatProgressBarModule, MatSidenavModule, MatButtonModule, FontAwesomeModule, LogsAgGridModule],
  declarations: [JobLogsComponent],
  exports: [JobLogsComponent],
})
export class JobLogsModule {}
